export default ({
  sensor: {
    model: { name },
    manufacturer: { name: manufacturerName },
  },
}) => name === 'Cookie' && manufacturerName === 'SEN.SE'
